import { number, largerEq, smaller, sum, multiply, round, floor } from 'mathjs'
import moment from 'moment'
import Vue from 'vue'
import { review_score_values, get_beds } from '@bookingv3/resources'
const decimals = 2

export function markup(price) {

  let mu = JSON.parse(atob(Vue.prototype.$config.mu)),
    markups = mu['DEFAULT'] || [],
    pricerange_markup = 0,
    customer_markup = number(mu.ADD.p || 0.1),
    mu_percent = customer_markup,
    mu_display_percent = (mu.DISPLAY) ? mu.DISPLAY.p : 0

  markups.forEach(m => {
    if (largerEq(number(price), number(m.min))) {
      pricerange_markup = number(m.p)
    } else {
      return
    }
  })

  if (Vue.prototype.$config.forced_mu) {
    // caso CONFIRM -> markup forzato da confirm()
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu))
  } else {
    mu_percent = round(sum(pricerange_markup, customer_markup), 3) // percentuale markup 3 decimali
  }


  let markup = round(multiply(price, mu_percent), decimals)
  let live_price = round(sum(price, markup), decimals)

  let display_markup = round(multiply(price, mu_display_percent), decimals)
  let display_price = round(sum(price, display_markup), decimals)

  if (smaller(live_price, price)) live_price = price

  /*window.console.table({
    price: price,
    mu_percent: mu_percent,
    markup: markup,
    live_price: live_price,
    display_price: display_price,
  })*/


  return {
    markup: String(markup), // ammontare del markup
    live_price: String(live_price), // markup su prezzo netto
    display_price: String(display_price), // markup "finto" su prezzo commissionabile
  }

}

export function reverse_markup(live_price) {
  let mu = JSON.parse(atob(Vue.prototype.$config.mu));
  let markups = mu["DEFAULT"] || [];
  let customer_markup = number(mu.ADD.p || 0.1);
  let mu_percent = customer_markup;
  let pricerange_markup = 0;

  if (Vue.prototype.$config.forced_mu) {
    mu_percent = JSON.parse(atob(Vue.prototype.$config.forced_mu));

    let price = number(live_price) / (1 + mu_percent);
    price = round(price, decimals);

    return {
      price: String(price),
      mu_percent: mu_percent,
      customer_markup: customer_markup,
    };
  }

  let sorted_markups = [...markups].sort(
    (a, b) => number(b.min) - number(a.min)
  );

  for (let i = 0; i < sorted_markups.length; i++) {
    let test_pricerange_markup = number(sorted_markups[i].p);
    let test_mu_percent = round(
      sum(test_pricerange_markup, customer_markup),
      3
    );

    let test_price = number(live_price) / (1 + test_mu_percent);
    test_price = round(test_price, decimals);

    if (largerEq(number(test_price), number(sorted_markups[i].min))) {
      let markup_test = round(multiply(test_price, test_mu_percent), decimals);
      let live_price_test = round(sum(test_price, markup_test), decimals);

      if (smaller(live_price_test, test_price)) {
        live_price_test = test_price;
      }

      if (number(live_price_test) === number(live_price)) {
        return {
          price: String(test_price),
          mu_percent: test_mu_percent,
          pricerange_markup: test_pricerange_markup,
          customer_markup: customer_markup,
        };
      }
    }
  }

  mu_percent = customer_markup;
  let price = number(live_price) / (1 + mu_percent);
  price = round(price, decimals);

  return {
    price: String(price),
    mu_percent: mu_percent,
    pricerange_markup: pricerange_markup,
    customer_markup: customer_markup,
  };
}

export function round_up(price) {
  return round(price, decimals)
}

export function format_date_with_month(time) {
  return moment(time, ['YYYY-MM-DD', 'DD-MM-YYYY']).locale('it').format('DD MMMM YYYY')
}

export function map_markers(items, availability, sass) {
  let markers = []
  if (!items) return []
  items.forEach((item) => {
    let color = '#999999',
      z_index = 1,
      copy = ''

    if (number(item.price) <= availability) {
      color = sass('primary')
      z_index = 10
    }
    else {
      copy = '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>'
    }

    let stars = '',
      stars_value = number(item.stars)
    if (stars_value > 0) {
      stars += '<div class="stars">'
      for (let i = 0; i < stars_value; i++) {
        stars += '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>'
      }
      stars += '</div>'
    }

    let review_score_value = number(item.salabamScore),
      review_score = '',
      review_desc = ''
    if (review_score_value) {
      let review_score_desc = review_score_values.filter(s => { return s.value >= floor(review_score_value) })
      if (review_score_desc.length > 0) review_desc = review_score_desc.reverse()[0].short_label + '<br>'
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`
    }

    markers.push({
      color: color,
      name: item.name,
      content:
        `<div class="info-window">
              <div class="info-window__image">
                <img src="${item.imageUrl}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${item.name}</div>
                    <div class="address">${item.full_address}</div>
                  </div>
                  <div class="right">
                    <div class="price">${item.price}€</div>
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.location.latitude),
        lng: number(item.location.longitude)
      },
      icon: {
        url: 'data:image/svg+xml;base64,' + window.btoa(
          '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g filter="url(#filter0_d_1016_36)">' +
          '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
          '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
          '</g>' +
          '<g filter="url(#filter1_d_1016_36)">' +
          '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
          '</g>' +
          '<defs>' +
          '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '</defs>' +
          '</svg>'
        ),
      },
      item: item,
      z_index: z_index,
    })
  })
  return markers
}

export function map_markers_v3(items, availability, sass) {
  let markers = []
  if (!items) return []
  items.forEach((item) => {
    let color = '#999999',
      z_index = 1,
      copy = ''

    if (number(item.price.total) <= availability) {
      color = sass('primary')
      z_index = 10
    }
    else {
      copy = '<div class="copy">\
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g fill="var(--color)" id="_01_align_center" data-name="01 align center"><path d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z" /><rect x="11" y="5" width="2" height="10" /><rect x="11" y="17" width="2" height="2" /></g></svg>\
          Credito non sufficiente!</div>'
    }

    let stars = '<div class="stars">'
    if (item.stars) {
      let stars_value = number(item.stars)
      if (stars_value > 0) {
        stars += '<div class="stars">'
        for (let i = 0; i < stars_value; i++) {
          stars += '<svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="star fill" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-star-fill b-icon bi text-secondary"><g><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></g></svg>'
        }
        stars += '</div>'
      }
    }
    else stars += '-</div>'

    let review_score_value = number(item.accommodations_details.salabam_score),
      review_score = '',
      review_desc = ''
    if (review_score_value) {
      let review_score_desc = review_score_values.filter(s => { return s.value >= floor(review_score_value) })
      if (review_score_desc.length > 0) review_desc = review_score_desc.reverse()[0].short_label + '<br>'
      review_score += `<div class="score">${review_desc} ${review_score_value}/10</div>`
    }

    const price = `€ ${get_live_price_tax_free(item)}` // live_price senza tasse di soggiorno

    markers.push({
      color: color,
      name: item.accommodations_details.name,
      content:
        `<div class="info-window">
              <div class="info-window__image">
                <img src="${item.accommodations_details.image_url}">
              </div>
              <div class="info-window__text">
                <div class="top">
                  <div class="left">
                    <div class="name">${item.accommodations_details.name}</div>
                    <div class="address">${item.accommodations_details.address}</div>
                  </div>
                  <div class="right">
                    <div class="price">${price}€</div>
                  </div>
                </div>
                <div class="ratings">${stars}${review_score}</div>
                ${copy}
              </div>
              <div class="info-window__button"><button class="btn btn-primary">Vai alla struttura</button></div>
            </div>`,
      position: {
        lat: number(item.accommodations_details.coordinates.latitude),
        lng: number(item.accommodations_details.coordinates.longitude)
      },
      icon: {
        url: 'data:image/svg+xml;base64,' + window.btoa(
          '<svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<g filter="url(#filter0_d_1016_36)">' +
          '<rect x="4" y="2" width="20" height="20" rx="10" fill="' + color + '"/>' +
          '<rect x="5" y="3" width="18" height="18" rx="9" stroke="white" stroke-width="2"/>' +
          '</g>' +
          '<g filter="url(#filter1_d_1016_36)">' +
          '<path d="M14.5 26L11.4689 20.75L17.5311 20.75L14.5 26Z" fill="white"/>' +
          '</g>' +
          '<defs>' +
          '<filter id="filter0_d_1016_36" x="0" y="0" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '<filter id="filter1_d_1016_36" x="7.46892" y="18.75" width="14.0622" height="13.25" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
          '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
          '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>' +
          '<feOffset dy="2"/>' +
          '<feGaussianBlur stdDeviation="2"/>' +
          '<feComposite in2="hardAlpha" operator="out"/>' +
          '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"/>' +
          '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1016_36"/>' +
          '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1016_36" result="shape"/>' +
          '</filter>' +
          '</defs>' +
          '</svg>'
        ),
      },
      price_label: price,
      item: item,
      z_index: z_index,
    })
  })
  return markers
}

export function get_live_price_tax_free(property) {
  // live_price senza tasse di soggiorno
  return round_up(markup(property.products[0].price.total_tax_free).live_price)
}

export function format_beds(bed_options) {
  let beds = []

  bed_options.forEach(bed_option => {
    bed_option.bed_configurations.forEach(bed_conf => {
      const arr_configuration = bed_conf.configuration.map(conf =>
        get_beds(conf.bed_type, conf.number_of_beds)
      )
      beds.push(arr_configuration)
    })
  })

  return beds = beds.map(option => option.join(' e ')).join(' oppure ')
}

/**
 * Deprecata in api v4 - usare direttamente pricing.total_tax_free con markup()
 */
// export function get_live_price_no_tax(pricing, book_price = null, extra_charges = null) {
//   if (!pricing) return {}
//   /* TODO scorporo tasse:
//   * - deprecato (spostato a backend) su V4
//   * - lasciato per retrocompatibilità V3
//   * - nelle V4 al posto di pricing.book verrà pricing.total_tax_free con tasse già scorporate a BE
//   */
//   const charges = extra_charges !== null ? extra_charges : pricing.extra_charges,
//     tax_22 = charges.included.find(tax => tax.charge === 22),
//     base_price = book_price !== null ? book_price : pricing.book,
//     tax_excluded_price = subtract(number(base_price), (tax_22 && tax_22.total_amount) ? tax_22.total_amount : 0)
//   /* fine TODO scorporo tasse */
//   return round_up(markup(tax_excluded_price).live_price) // live_price senza tasse di soggiorno
// }

export function get_public_price(price) {
  if (!price) return null

  return round_up(markup(price).live_price) // live_price senza tasse di soggiorno
}